import { copyObject } from '@/lib/objects'

export const DEFAULT_AGENCY_CONCLUSION = () => ({
  original: '',
  translate: '',
  public_date: '',
  link: '',
})

export const DEFAULT_AGENCIES_LIST = () => [
  {
    name: 'NICE',
    data: [DEFAULT_AGENCY_CONCLUSION()],
  },
  {
    name: 'IQWIG',
    data: [DEFAULT_AGENCY_CONCLUSION()],
  },
  {
    name: 'CDA',
    data: [DEFAULT_AGENCY_CONCLUSION()],
  },
]

export const DEFAULT_INDICATION = () => ({
  text: '',
  agencies: DEFAULT_AGENCIES_LIST(),
})

export const EX_AGENCIES_DEFAULT = () => ({
  indications: [DEFAULT_INDICATION()],
})

export function isLegacyAgenciesFormat(raw) {
  return !!raw?.data && !raw?.indications?.length
}

export function normalizeAgenciesExpertise(raw) {
  if (raw?.indications?.length) {
    return {
      indications: raw.indications.map(ind => ({
        text: ind?.text ?? '',
        agencies: (ind.agencies?.length
          ? ind.agencies
          : DEFAULT_AGENCIES_LIST()
        ).map(agency => ({
          name: agency.name,
          data: (agency.data?.length
            ? agency.data
            : [DEFAULT_AGENCY_CONCLUSION()]
          ).map(item => ({
            original: item?.original ?? '',
            translate: item?.translate ?? '',
            public_date: item?.public_date ?? '',
            link: item?.link ?? '',
          })),
        })),
      })),
    }
  }
  if (isLegacyAgenciesFormat(raw)) {
    return {
      indications: [
        {
          text: '',
          agencies: copyObject(raw.data),
        },
      ],
    }
  }
  return EX_AGENCIES_DEFAULT()
}

export function indicationTabLabel(ind, index) {
  const text = String(ind?.text || '').trim()
  if (!text) return `Показ. ${index + 1}`
  const line = text.split('\n')[0].trim()
  if (line.length <= 14) return line
  return `${line.slice(0, 14)}…`
}

export function indicationHasContent(ind) {
  const text = String(ind?.text || '').trim()
  if (text) return true
  return ind.agencies?.some(a =>
    a.data?.some(d => d.translate || d.original || d.link)
  )
}

/** Строки таблицы агентств для Word (показание + три агентства). */
export function buildAgenciesTableRows(expertise, about = null) {
  const normalized = normalizeAgenciesExpertise(expertise)
  const rows = normalized.indications
    .filter(indicationHasContent)
    .map(ind => ({
      condition: String(ind.text || '').trim() || '—',
      agencies: ind.agencies,
    }))

  if (rows.length) return rows

  if (isLegacyAgenciesFormat(expertise)) {
    return [
      {
        condition: about?.condition || '—',
        agencies: expertise.data,
      },
    ]
  }

  return [
    {
      condition: about?.condition || '—',
      agencies: DEFAULT_AGENCIES_LIST(),
    },
  ]
}
